import type { Intent } from '@jet/environment/dispatching';
import type { SectionChangeInstruction } from '../../../models/invalidation/change-instruction/SectionChangeInstruction';
import type { RefreshIntent } from '../../refresh-page/RefreshPageIntent';

export interface RefreshRecentlyPlayedIntent
    extends RefreshIntent<SectionChangeInstruction> {
    $kind: 'RefreshRecentlyPlayedIntent';
    refreshPath: string;
}

export function makeRefreshRecentlyPlayedIntent(
    refreshPath: string,
    reason: string,
): RefreshRecentlyPlayedIntent {
    return {
        $kind: 'RefreshRecentlyPlayedIntent',
        refreshPath,
        reason,
    };
}

export function isRefreshRecentlyPlayedIntent(
    intent: Intent<unknown>,
): intent is RefreshRecentlyPlayedIntent {
    return intent.$kind === 'RefreshRecentlyPlayedIntent';
}
